import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function ParametrosAgenda() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item active">Parámetros de agenda</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Parámetros de agenda</h1>
                                        <p className="dash-subtitle mb-0">Agendas, estados, bloqueos y unidades</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/settings" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver a configuración
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-calendar-alt"></i></span>
                                        Opciones
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/crear-agendas" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-calendar-plus"></i></div>
                                            <p className="quick-title">Crear agendas</p>
                                            <p className="quick-sub">Definición de Agendas y Recursos</p>
                                        </Link>

                                        <Link to="/estados-cita" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-flag"></i></div>
                                            <p className="quick-title">Estados de las citas</p>
                                            <p className="quick-sub">Flujo y Estados Operativos</p>
                                        </Link>

                                        <Link to="/bloqueos-agenda" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-user-clock"></i></div>
                                            <p className="quick-title">Bloqueo de horarios</p>
                                            <p className="quick-sub">Restricciones por Agenda</p>
                                        </Link>

                                        <Link to="/unidades-atencion" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-clinic-medical"></i></div>
                                            <p className="quick-title">Unidades de Atención</p>
                                            <p className="quick-sub">Consultorios y Sedes</p>
                                        </Link>

                                        <Link to="/bloqueos-unidades" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-ban"></i></div>
                                            <p className="quick-title">Bloqueos de Unidades</p>
                                            <p className="quick-sub">Horarios no Disponibles por Unidad</p>
                                        </Link>

                                        <Link to="/horario-atencion" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-business-time"></i></div>
                                            <p className="quick-title">Horario de Atención</p>
                                            <p className="quick-sub">Rango horario y duración general de citas</p>
                                        </Link>

                                        <Link to="/planes-agendamiento" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-layer-group"></i></div>
                                            <p className="quick-title">Administrador de Planes</p>
                                            <p className="quick-sub">Paquetes de Servicios y Control de Cantidad/Sesiones</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default ParametrosAgenda;
